import React from "react";
import ReactDOM from "react-dom";

export default class ModuleInputsGroup extends React.Component {
    constructor(props) {
        super(props);
        
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }


    getConfig(key) {
        return this.props[key];
    }

    render() {

        return (
            <div className="panel-group" role="tablist">
                <div className="panel panel-default">
                    <div className="panel-heading" role="tab" style={{ padding: "0", paddingLeft: "15px",}}>
                        <div className={"row"}>
                            <div className={"col-md-10"} style={{ padding: "10px" }}>
                                <div className="panel-title"
                                     onClick={() => {
                                         this.getDomSelf().find(".collapse[data-tracker='moduleInputs']").collapse('toggle');
                                     }}
                                >
                                    <i className={"fe icon-package"} />
                                    &nbsp;&nbsp;Start 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="panel-collapse collapse in" role="tabpanel" data-tracker="moduleInputs">
                        <div className="panel-body">
                            <div className="row">
                                <table className={"table table-condensed"}>
                                    <thead>
                                    <tr style={{ color: "var(--theme-text-muted)", fontSize: "14px" }}>
                                        <td style={{ width: "20%" }}>{"Local Variables"}</td>
                                            <td style={{ width: "40%" }}>{ "Default Value"}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.moduleInputs.map((modInputs) => {
                                        return <tr key={modInputs.id}>
                                            <td><label><i className={"fe icon-hash"} />{modInputs.props.config.varName}</label></td>
                                            <td>{modInputs.props.config.defaultValue.toString()}
                                                
                                            </td>
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
